import { IPlan } from "../models/plan";

export const SubsriptionPlansDevelopment: IPlan[] = [
	{
		name: "Free",
		monthly: {
			priceId: "price_1S1UJ1IKfZQwFOEAHXAmLreo",
			price: 0,
		},
		yearly: {
			priceId: "price_1S1UJ1IKfZQwFOEAHXAmLreo",
			price: 0,
		},
		discount: "Test drive with free tier plan",
		features: [
			"Single User",
			"Single Agent",
			"100 Message credits",
			"5 Knowledge sources",
			"100 Table rows",
			"Advance AI models",
			"Advance Analytics",
			"Unlimited Integrations",
		],
		buttonText: "Get started",
	},
	{
		name: "Starter",
		monthly: {
			priceId: "price_1Sb9sZIKfZQwFOEAr4ZxfavC",
			price: 35,
		},
		yearly: {
			priceId: "price_1Sb9uWIKfZQwFOEAtUG7nA7v",
			price: 385,
		},
		discount: "Get 1 month free on yearly plan",
		features: [
			"2 Users",
			"2 Agents",
			"2000 monthly credits",
			"20 Knowledge sources",
			"1000 Table rows",
			"Advance AI models",
			"Advance Analytics",
			"Unlimited Integrations",
		],
		buttonText: "Subscribe",
	},
	{
		name: "Pro",
		monthly: {
			priceId: "price_1Sb9tPIKfZQwFOEAgbTUPay6",
			price: 105,
		},
		yearly: {
			priceId: "price_1Sb9vkIKfZQwFOEAf1M0UgVA",
			price: 1160,
		},
		discount: "Save $100 on yearly plan",
		features: [
			"5 Users",
			"5 Agents",
			"10,000 monthly credits",
			"100 Knowledge sources",
			"5,000 Table rows",
			"Advance AI models",
			"Unlimited Integrations",
		],
		buttonText: "Subscribe",
	},
	{
		name: "Business",
		monthly: {
			priceId: "price_1Sb9tyIKfZQwFOEA5hJpIDNR",
			price: 399,
		},
		yearly: {
			priceId: "price_1Sb9waIKfZQwFOEAJ2hcxpeQ",
			price: 4588,
		},
		discount: "Save $200 on yearly plan",
		features: [
			"100 Users",
			"20 Agents",
			"50,000 monthly credits",
			"500 Knowledge sources",
			"20,000 Table rows",
			"Advance AI models",
			"Advance Analytics",
			"Unlimited Integrations",
		],
		buttonText: "Subscribe",
	},
];
export const SubsriptionPlansProduction: IPlan[] = [
	{
		name: "Free",
		monthly: {
			priceId: "price_1Qj7Q0IDQPUeikoE24gmfqTa",
			price: 0,
		},
		yearly: {
			priceId: "price_1Qj7Q0IDQPUeikoE24gmfqTa",
			price: 0,
		},
		discount: "Test drive with free tier plan",
		features: [
			"Single User",
			"Single Agent",
			"100 Message credits",
			"5 Knowledge sources",
			"100 Table rows",
			"Advance AI models",
			"Advance Analytics",
			"Unlimited Integrations",
		],
		buttonText: "Get started",
	},
	{
		name: "Starter",
		monthly: {
			priceId: "price_1Scx6VIDQPUeikoEfZJjV5Hg",
			price: 35,
		},
		yearly: {
			priceId: "price_1Scx6VIDQPUeikoEjhtMTtyN",
			price: 385,
		},
		discount: "Get 1 month free on yearly plan",
		features: [
			"2 Users",
			"2 Agents",
			"2000 monthly credits",
			"20 Knowledge sources",
			"1000 Table rows",
			"Advance AI models",
			"Advance Analytics",
			"Unlimited Integrations",
		],
		buttonText: "Subscribe",
	},
	{
		name: "Pro",
		monthly: {
			priceId: "price_1Scx6MIDQPUeikoEU9x82Zmg",
			price: 105,
		},
		yearly: {
			priceId: "price_1Scx6MIDQPUeikoEQetJ8tYF",
			price: 1160,
		},
		discount: "Save $100 on yearly plan",
		features: [
			"5 Users",
			"5 Agents",
			"10,000 monthly credits",
			"100 Knowledge sources",
			"5,000 Table rows",
			"Advance AI models",
			"Unlimited Integrations",
		],
		buttonText: "Subscribe",
	},
	{
		name: "Business",
		monthly: {
			priceId: "price_1Scx6CIDQPUeikoEWqJ1RNOL",
			price: 399,
		},
		yearly: {
			priceId: "price_1Scx6BIDQPUeikoEiIMHKccc",
			price: 4588,
		},
		discount: "Save $200 on yearly plan",
		features: [
			"100 Users",
			"20 Agents",
			"50,000 monthly credits",
			"500 Knowledge sources",
			"20,000 Table rows",
			"Advance AI models",
			"Advance Analytics",
			"Unlimited Integrations",
		],
		buttonText: "Subscribe",
	},
];

export const EnterprisePlan: IPlan = {
	name: "Enterprise",
	monthly: {
		priceId: "",
		price: 299,
	},
	yearly: {
		priceId: "",
		price: 3288,
	},
	discount: "Save $300 on yearly plan",
	features: [
		"100+ Users",
		"100+ Agents",
		"500K+ Message credits (Monthly)",
		"500+ Knowledge sources",
		"100K+ Table rows",
		"Advance AI models",
		"Unlimited Integrations",
	],
	additionalFeatures: [
		"2X faster request",
		"Priority support",
		"Custom onboarding",
		"Custom API",
		"Advance Analytics",
	],
	buttonText: "Subscribe",
}; 

export const SubscriptionPlans = process.env.NODE_ENV === "development" ? 
	SubsriptionPlansDevelopment : SubsriptionPlansProduction;